import React from "react";
import {Box, Button, Container, Typography} from "@mui/material";
import {addService, getRiyoDaySearch} from "../../../api/client";

export default function Step4(props) {
  // const loadParams = (nm) => {
  //   return sessionStorage.getItem(nm) || "";
  // };
  const saveParams = (nm, val) => {
    return sessionStorage.setItem(nm, val);
  };
  const loadJson = (nm) => {
    return JSON.parse(sessionStorage.getItem(nm)) || [];
  };
  const saveJson = (nm, val) => {
    return sessionStorage.setItem(nm, JSON.stringify(val));
  };
  async function nextStep(val) {
    const svkCd = val.svkCd;
    if (!Boolean(svkCd)) {
      props.errorFunc({response: {data: {errors: "基本サービスを選択してください。"}}})
    } else {
      const result = await addService(
        {ymdDt: props.propState.date, bsJg: props.propState.jgCd, riyoNo: props.propState.riyoNo, svsCd: val.svsCd, svkCd: svkCd, hourfDt: val.hourfDt, hourtDt: val.hourtDt, array: val}
      ).catch(error => props.errorFunc(error));
      if (Boolean(result)) {
        const data = await getRiyoDaySearch({ymdDt: props.propState.date, bsJg: props.propState.jgCd, riyoNo: props.propState.riyoNo}).catch(error => props.errorFunc(error));
        saveJson("data", data.data);
        props.setToastState({...props.toastState, error: false, message: result.data.message});
        props.setPropState({...props.propState, edit: false});
        sessionStorage.removeItem("edit");
        sessionStorage.removeItem("activeStep");
        sessionStorage.removeItem("editScheduleStepper");
        sessionStorage.removeItem("svsForm");
        sessionStorage.removeItem("svsList");
        sessionStorage.removeItem("svkCdList");
      };
    };
  };

  return (
    <Container>
      <Box
        sx = {{mt: 2, mb: 4}}
      >
        <Typography>
          {(loadJson("svkCdList").find((svkCd) => svkCd[0] === props.getValues("svkCd")) || [""])[0].split("_")[0] || "--"}
          ：
          {(loadJson("svkCdList").find((svkCd) => svkCd[0] === props.getValues("svkCd")) || [])[1] || "--"}
        </Typography>
        <Typography>
          {props.getValues("hourfDt")}
          ～
          {props.getValues("hourtDt")}
        </Typography>
      </Box>
      <Box
        sx = {{display: "flex", mt: 2, mb: 2}}
      >
        <Button
          className = "btn-prev"
          onClick = {() => {
            props.setState({...props.state, activeStep: props.state.activeStep - 1});
            saveParams("activeStep", props.state.activeStep - 1);
          }}
          sx = {{display: "block", mr: "auto", pt: 0.5, pb: 0.5, width: 120}}
        >
          <Typography
            className = "btn-txt-sm"
          >
            戻る
          </Typography>
        </Button>
        <Button
          className = "btn-submit"
          onClick = {() => nextStep(props.getValues())}
          sx = {{display: "block", ml: "auto", pt: 0.5, pb: 0.5, width: 120}}
        >
          <Typography
            className = "btn-txt-sm"
          >
            登録
          </Typography>
        </Button>
      </Box>
    </Container>
  );
};
